import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AgendaService {// In AgendaService
  public currentDateSubject = new BehaviorSubject<Date>(new Date()); // Default initial date or null

  public currentDate: Date = new Date();

  public emitDateChanged(date: Date) {
    this.currentDate = date;
    this.currentDateSubject.next(date);
  }
}
